<template>
	<div v-if="isCommercial || isAdmin || isMainCommercial || isOenology">
		<step-status-component v-if="req && req.status" :status="req.status" :allDeliveryDateOenology="req.allDeliveryDateOenology" :allWineryValid="req.allWineryValid"/>

		<card :id="req.status != 'Creado' ? id : null" :exportXlsx="true" :history="true"
			:title="'Solicitud de Muestra N° ' + id" bg="bg-dark text-white" icon="glass-martini"
			@exportRequest="exportRequest(id)" @showHistory="showHistory(id)">
			<template v-slot:titleBadge>
				<management-countdown-badge :deadline="req.dispatchManagementDeadline" :sample-state="req.sampleState" />
			</template>
			<card class="card cardShadow-light" title="Datos Principales">
				<div class="table-responsive">
					<table class="table">
						<tr>
							<th style="width: 20%">Unidad de Negocio:</th>
							<td style="width: 30%">{{ req.businessUnitName }}</td>
							<th style="width: 20%">Centro de Costo:</th>
							<td style="width: 30%">
								<div v-if="req.sampleState < 6" class="row" style="margin: 0px !important">
									<div class="form-group col-md-10" style="padding: 0px !important">
										<v-select append-to-body :options="assignedCostCenters" :filterable="false" v-model="costCenter" @search="onSearch" :disabled="!hasMultipleCeco">
											<template slot="no-options">
												No se encontraron registros
											</template>
											<template slot="option" slot-scope="option">
												<div class="d-center">
													{{ option.label }}
												</div>
											</template>
											<template slot="selected-option" slot-scope="option">
												<div class="selected d-center">
													{{ option.label }}
												</div>
											</template>
										</v-select>
									</div>
									<div v-if="hasMultipleCeco">
										<button class="btn btn-primary ml-4" title="Actualizar Fecha" type="button"
											@click="updateCostCenter">
											<i class="fas fa-save"></i>
										</button>
									</div>
								</div>
								<span v-else="">{{ req.costCenterName }}</span>
							</td>
						</tr>
						<tr>
							<th style="width: 20%">Despacho Progresivo:</th>
							<td style="width: 30%">{{ req.progressDispatch }}</td>
							<th style="width: 20%">Objetivo de la Muestra:</th>
							<td style="width: 30%">{{ req.sampleTargetName }}</td>
						</tr>
						<tr>
							<th style="width: 20%">Detalles de objetivo:</th>
							<td style="width: 30%">{{ req.sampleReasonName }}</td>
							<th style="width: 20%">Fecha de Envío:</th>
							<td style="width: 30%">{{ req.sendedAtString }}</td>
						</tr>
						<tr>
							<th style="width: 20%">Fecha Requerida Despacho:</th>
							<td style="width: 30%">
								<div class="row" style="margin: 0px !important">
									<div class="form-group col-md-9" style="padding: 0px !important; margin-bottom: 0px;">
										<input id="required-dispatch-date" v-model="dispatchDate" :min="minDate" class="form-control" type="date" />
									</div>
									<div>
										<button class="btn btn-primary ml-2" title="Actualizar Fecha" type="button" @click="updateDispatchDate">
											<i class="fas fa-save"></i>
										</button>
									</div>
								</div>
							</td>
							<th style="width: 20%">Fecha/Hora Límite de Gestión:</th>
							<td style="width: 30%">
								<div v-if="(isAdmin || isOenology) && req.sampleState >= 1 && req.sampleState < 6" class="row" style="margin: 0px !important">
									<div class="form-group col-md-4" style="padding: 0px !important; margin-bottom: 0px;">
										<input v-model="managementDeadline" :min="sendedAtLocal" class="form-control" type="datetime-local" />
									</div>
									<div>
										<button class="btn btn-primary ml-4" title="Actualizar Fecha/Hora Límite" type="button" @click="updateDeadline">
											<i class="fas fa-save"></i>
										</button>
									</div>
								</div>
								<template v-else>
									<span v-if="req.dispatchManagementDeadlineString">{{ req.dispatchManagementDeadlineString }}</span>
									<span v-else-if="req.sampleState !== 0" class="text-muted" title="Se calcula al enviar la muestra: fecha/hora de envío + 72 horas hábiles (domingo inhábil). Si el envío es a partir de las 16:30, el conteo comienza al día siguiente a las 08:00.">Pendiente de envío</span>
									<span v-else class="text-muted">Sin Registro</span>
								</template>
							</td>
						</tr>
						<tr v-if="wineryDispatched && req.progressDispatch == 'No'">
							<th style="width: 20%">Fecha Despacho total desde Bodega</th>
							<td colspan="3">{{ req.wineryDispatchDateString }}</td>
						</tr>
					</table>
				</div>
			</card>
			<dispatch-component :id="id" @reloadDispatch="index" :dispatch="dispatch" @setDispatch="setDispatch" />
			<card v-if="
				(wineryDispatched || send) &&
				req.progressDispatch == 'Si' &&
				anyWineryDispatch
			" class="card cardShadow-light" title="Datos Despacho desde Bodega">
				<div class="table-responsive">
					<table class="table">
						<tr>
							<th>Id</th>
							<th>Tipo de Muestra</th>
							<th>SKU</th>
							<th>Marca</th>
							<th>Mezcla Comercial</th>
							<th>Vino</th>
							<th>Cosecha Final <i class="fas fa-info-circle text-muted ml-1" title="Para despacho"></i></th>
							<th>Fecha Despacho desde Bodega</th>
						</tr>
						<tr v-for="r in requestDetailsWineryDispatch" :key="r.id">
							<td>{{ r.id }}</td>
							<td>{{ r.requestType.name }}</td>
							<td>{{ r.sku }}</td>
							<td>{{ r.brand }}</td>
							<td v-if="r.comercialMixCode">
								{{ r.comercialMixCode }} {{ r.comercialMix }}
							</td>
							<td v-else></td>
							<td>
								{{ r.variety }} {{ r.valley }} {{ r.quality }}
							</td>
							<td>{{ r.finalHarvest }}</td>
							<td>{{ r.wineryDispatchString }}</td>
						</tr>
					</table>
				</div>
			</card>
			<create-detail :dispatch="dispatch" :requestId="id" :status="req.status" :req="req" />
			<modal id="showHistory" :lg="true" title="Historial de solicitud">
				<history-modal-request :historyOptions="historyOptions"></history-modal-request>
			</modal>
		</card>
	</div>
</template>

<script>
import { Get, Put } from "../../helper/axios.js";
import Card from "../../components/Card.vue";
import CreateDetail from "./detail/Create.vue";
import DispatchComponent from "./detail/dispatch.vue";
import HistoryModalRequest from "@/views/requests/history/HistoryModalRequest.vue";
import $ from "jquery";
import _ from "lodash";
import { base64ToArrayBuffer } from '@/helper/fileHelper.js';

export default {
	components: {
		HistoryModalRequest,
		Card,
		CreateDetail,
		DispatchComponent,
	},
	data() {
		return {
			historyOptions: {
				id: null,
				history: [],
			},
			id: this.$route.params.id,
			apiUrl: this.$store.getters.apiUrl,
			Get,
			Put,
			isAdmin: this.$store.getters.isAdmin,
			isDispatcher: this.$store.getters.isDispatcher,
			isCommercial: this.$store.getters.isCommercial,
			isCourier: this.$store.getters.isCourier,
			isMainCommercial: this.$store.getters.isMainCommercial,
			isCommercialDispatcher: this.$store.getters.isCommercialDispatcher,
			isOenology: this.$store.getters.isOenology,
			req: {},
			dispatch: null,
			created: false,
			send: false,
			wineryDispatched: false,
			validWineryDispatch: false,
			dispatched: false,
			confirmed: false,
			dispatchDate: "",
			minDate: "",
			managementDeadline: "",
			sendedAtLocal: "",
			requestDetails: [],
			anyWineryDispatch: false,
			history: [],
			invalid: false,
			rejected: false,
			cancelled: false,
			validComponents: false,
			rejectQuality: false,
			validQuality: false,
			costCenters: [],
            costCenter: {},
            costCenterUsers: [],
            costCenterUsersLoaded: false,
            businessUnitId: null
		};
	},
	created() {
		if (this.id) {
			this.index();
		}
	},
	methods: {
		index(){
			this.$store.commit("setLoading", true);
			this.Get(this.apiUrl + "v1/requestsamples/" + this.id, (res) => {
				this.req = res.data;
				this.$store.commit("setLoading", false);
				var createdDate = new Date(
					res.data.createdAt.split("-").reverse().join("-")
				);
				this.history = res.data.histories;
				var dd = String(createdDate.getDate() + 3).padStart(2, "0");
				var mm = String(createdDate.getMonth() + 1).padStart(2, "0");
				var yyyy = createdDate.getFullYear();
				this.minDate = yyyy + "-" + mm + "-" + dd;
                this.businessUnitId = res.data.businessUnitId;
                this.costCenter = {
                    code: res.data.costCenterId,
                    label: res.data.costCenterName,
                }
                this.getCostCenters(res.data.businessUnitId);
                this.getCostCenterUsers(res.data.businessUnitId);
				this.dispatchDate = res.data.requiredDispatchDateString
					.split("-")
					.reverse()
					.join("-");
				// Formato datetime-local ("yyyy-MM-ddTHH:mm") a partir del ISO del backend.
				this.sendedAtLocal = res.data.sendedAt ? res.data.sendedAt.substring(0, 16) : "";
				this.managementDeadline = res.data.dispatchManagementDeadline
					? res.data.dispatchManagementDeadline.substring(0, 16)
					: "";
				if (res.data.status === "Cancelado") {
					this.created = true;
					this.cancelled = true;
				}
				if (res.data.status == "Creado") this.created = true;
				if (res.data.status == "Enviado") {
					this.created = true;
					this.send = true;
				}
				if (res.data.status === "Invalidado") {
					this.created = true;
					this.send = true;
					this.invalid = true;
				}
				if (res.data.status === "Componentes_en_revision") {
					this.created = true;
					this.send = true;
					this.validWineryDispatch = true;
				}
				if (res.data.status === "Calidad") {
					this.created = true;
					this.send = true;
					this.validWineryDispatch = true;
					this.validToDispatcher = true;
					this.validComponents = true;
				}
				if (res.data.status === "Validado_para_despacho") {
					this.created = true;
					this.send = true;
					this.validComponents = true;
					this.validWineryDispatch = true;
					this.validQuality = true;
				}
				if (res.data.status === "Rechazo_por_calidad") {
					this.created = true;
					this.send = true;
					this.validComponents = true;
					this.validWineryDispatch = true;
					this.rejectQuality = true;
				}
				if (res.data.status === "Rechazado") {
					this.created = true;
					this.send = true;
					this.validWineryDispatch = true;
					this.rejected = true;
				}
				if (res.data.status === "Despachado_Bodega") {
					this.created = true;
					this.send = true;
					this.validWineryDispatch = true;
					this.wineryDispatched = true;
					this.validComponents = true;
					this.validToDispatcher = true;
					this.validQuality = true;
				}
				if (res.data.status === "Despachado") {
					this.created = true;
					this.send = true;
					this.validWineryDispatch = true;
					this.wineryDispatched = true;
					this.dispatched = true;
					this.validComponents = true;
					this.validToDispatcher = true;
					this.validQuality = true;
				}
				if (res.data.status === "Confirmado") {
					this.created = true;
					this.send = true;
					this.validWineryDispatch = true;
					this.wineryDispatched = true;
					this.dispatched = true;
					this.confirmed = true;
					this.validQuality = true;
					this.validComponents = true;
					this.validToDispatcher = true;
				}
			});
			this.$store.commit("setLoading", true);
			this.Get(this.apiUrl + "v1/dispatchs?sampleId=" + this.id, (res) => {
				this.dispatch = res.data;
				this.$store.commit("setLoading", false);
			});

			this.$store.commit("setLoading", true);
			this.Get(
				this.apiUrl + "v1/requestsample/" + this.id + "/details",
				(res) => {
					this.requestDetails = res.data;
					this.$store.commit("setLoading", false);
				}
			);
		},
		setDispatch(data) {
			this.dispatch = data;
		},
		updateDispatchDate() {
			if (this.dispatchDate >= this.minDate) {
				this.req.requiredDispatchDate = this.dispatchDate;
				this.$swal({
					title: "¿Desea Modificar la fecha requerida de Despacho?",
					icon: "info",
					showCancelButton: true,
					confirmButtonColor: "#3085d6",
					cancelButtonColor: "#d33",
				}).then((result) => {
					if (result.value) {
						this.$store.commit("setLoading", true);
						this.Put(
							this.apiUrl + "v1/dispatchDateRequest/" + this.id,
							this.req,
							() => {
								this.$store.commit("setLoading", false);
								window.toastr.success('La Fecha requerida de Despacho ha sido Modificada correctamente.');
								this.index();
							}
						);
					}
				});
			} else
				window.toastr.warning(
					"La Fecha requerida de despacho ingresada, No esta permitida"
				);
		},
		updateDeadline() {
			if (!this.managementDeadline) {
				window.toastr.warning("Debe ingresar la Fecha/Hora Límite de Gestión.");
				return;
			}
			if (this.sendedAtLocal && this.managementDeadline < this.sendedAtLocal) {
				window.toastr.warning("La Fecha/Hora Límite no puede ser anterior a la Fecha de Envío.");
				return;
			}
			this.$swal({
				title: "¿Desea Modificar la Fecha/Hora Límite de Gestión?",
				icon: "info",
				showCancelButton: true,
				confirmButtonColor: "#3085d6",
				cancelButtonColor: "#d33",
			}).then((result) => {
				if (result.value) {
					this.$store.commit("setLoading", true);
					this.Put(
						this.apiUrl + "v1/dispatchDateRequest/deadline/" + this.id,
						{ dispatchManagementDeadline: this.managementDeadline },
						() => {
							this.$store.commit("setLoading", false);
							window.toastr.success("La Fecha/Hora Límite de Gestión ha sido Modificada correctamente.");
							this.index();
						}
					);
				}
			});
		},
		exportRequest(id) {
			this.$store.commit("setLoading", true);
			this.Get(this.apiUrl + "v1/exportRequestSample/" + id, (res) => {
				var array = base64ToArrayBuffer(res.data);
				var a = window.document.createElement("a");
				a.href = window.URL.createObjectURL(
					new Blob([array], {
						type: "application/octet-stream",
					})
				);
				a.download = "FCOM " + id + ".xlsx";
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				this.$store.commit("setLoading", false);
			});
		},
		showHistory() {
			this.Get(`${this.apiUrl}v1/flowhistory/${this.req.id}`, (res) => {
				this.historyOptions.history = res.data;
				$("#showHistory").modal("show");
			});
		},
		getCostCenters(businessUnitId) {
            if (businessUnitId) {
                this.$store.commit("setLoading", true);
                this.Get(`${this.apiUrl}v1/businessunit/${businessUnitId}/costcenters`, (res) => {
                    this.costCenters = [];
                    res.data.forEach(item => { 
                        this.costCenters.push({
                            code: item.id,
                            label: `${item.name} (${item.description})`
                        });
                    });
                    this.$store.commit("setLoading", false);
                });
            }
        },
        getCostCenterUsers(businessUnitId) {
            if (businessUnitId) {
                this.$store.commit("setLoading", true);
                this.Get(`${this.apiUrl}v1/CostCenterUsers/GetCostCenterByUser/${businessUnitId}`, (res) => {
                    this.costCenterUsers = res.data || [];
                    this.costCenterUsersLoaded = true;
                    this.$store.commit("setLoading", false);
                });
            }
        },
        onSearch(search, loading) {
            if(search.length)
            {
                loading(true);
                this.search(loading, search, this)
            }
        },
        search: _.debounce((loading, search, vm) => {
            let data = "Search=" + search + "&Size=10&BusinessUnitId=" + vm.businessUnitId;
            vm.Get(vm.apiUrl + "v1/costCentersBusinessUnits?" + data, (res) => {
                vm.costCenters=[];
                res.data.forEach(item => { 
                    vm.costCenters.push({
                        code: item.id,
                        label: `${item.name} (${item.description})`
                    });
                });
            loading(false)
            });
        }, 500),
        updateCostCenter() {
			if (this.costCenter) {
				this.$swal({
					title: "¿Desea Modificar el Centro de Costo?",
					icon: "info",
					showCancelButton: true,
					confirmButtonColor: "#3085d6",
					cancelButtonColor: "#d33",
				}).then((result) => {
					if (result.value) {
						this.$store.commit("setLoading", true);
                        let data = {
                            id: this.id,
                            costCenterId: this.costCenter.code
                        }
						this.Put(this.apiUrl + "v1/RequestSamples/UpdateCostCenter", data, () => {
								this.$store.commit("setLoading", false);
                                window.toastr.success('Centro de Costo Actualizado Correctamente.');
                                this.index();
							}
						);
					}
				});
			} else
				window.toastr.warning("El Centro de Costo es Requerido");
		},
	},
	computed: {
		// El centro de costo solo es editable si el usuario tiene más de uno asignado.
		hasMultipleCeco() {
			return this.costCenterUsersLoaded && this.costCenterUsers.length > 1;
		},
		assignedCostCenters() {
			return (this.costCenterUsers || []).map(cc => ({
				code: cc.id,
				label: `${cc.name} (${cc.description})`
			}));
		},
		requestDetailsWineryDispatch() {
			var requestDetailsWineryDispatchList = [];
			this.requestDetails.forEach((element) => {
				if (element.wineryDispatch != null)
					requestDetailsWineryDispatchList.push(element);
			});
			return requestDetailsWineryDispatchList;
		},
	},
};
</script>
